var VERSION = function () {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require("../package.json").version;
  } catch (_unused) {
    return null;
  }
}();

export { VERSION as V };
